module.exports = __webpack_public_path__ + "static/media/weather.3acc84e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/weather.svg
// module id = 406
// module chunks = 7